import { render, staticRenderFns } from "./SectionButtons.vue?vue&type=template&id=28ccf6a2&scoped=true&"
import script from "./SectionButtons.vue?vue&type=script&lang=js&"
export * from "./SectionButtons.vue?vue&type=script&lang=js&"
import style0 from "./SectionButtons.vue?vue&type=style&index=0&id=28ccf6a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ccf6a2",
  null
  
)

export default component.exports